import { render, staticRenderFns } from "./LinkTenantSetting.vue?vue&type=template&id=255c20e2&scoped=true"
import script from "./LinkTenantSetting.vue?vue&type=script&lang=js"
export * from "./LinkTenantSetting.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSetting.vue?vue&type=style&index=0&id=255c20e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c20e2",
  null
  
)

export default component.exports